import { render, staticRenderFns } from "./userManageButton.vue?vue&type=template&id=e8a1ef32"
import script from "./userManageButton.vue?vue&type=script&lang=js"
export * from "./userManageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports